import { render, staticRenderFns } from "./preview-dialog.vue?vue&type=template&id=252cf7c3&"
import script from "./preview-dialog.vue?vue&type=script&lang=js&"
export * from "./preview-dialog.vue?vue&type=script&lang=js&"
import style0 from "./preview-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "preview-dialog.vue"
export default component.exports